{
    "ar": [
        "هل تريد قراءته باللغة عربي؟",
        "تغيير إلى اللغة عربي",
        "لا، شكرًا"
    ],
    "da": [
        "Vil du læse det på Dansk?",
        "Skift til Dansk",
        "Nej, tak"
    ],
    "de": [
        "Möchten Sie es auf Deutsch lesen?",
        "Zu Deutsch wechseln",
        "Nein, danke"
    ],
    "el": [
        "Θέλετε να το διαβάσετε στα Ελληνικά;",
        "Αλλαγή σε Ελληνικά",
        "Όχι, ευχαριστώ"
    ],
    "en": [
        "Do you want to read it in English?",
        "Change to English",
        "No, thanks"
    ],
    "es": [
        "¿Quieres leerlo en Español?",
        "Cambiar a Español",
        "No, gracias"
    ],
    "fi": [
        "Haluatko lukea sen kielellä Suomi?",
        "Vaihda kieleen Suomi",
        "Ei, kiitos"
    ],
    "fr": [
        "Voulez-vous le lire en Français ?",
        "Passer en Français",
        "Non merci"
    ],
    "he": [
        "רוצים לקרוא את הדף הזה בשפהעברית",
        "לשנות לשפה: עברית",
        "לא, תודה"
    ],
    "hu": [
        "Szeretné elolvasni Magyar nyelven?",
        "Váltás Magyar nyelvre",
        "Nem, köszönöm"
    ],
    "it": [
        "Vuoi leggerlo in Italiano?",
        "Cambia in Italiano",
        "No, grazie"
    ],
    "ja": [
        "日本語で確認しますか？",
        "日本語に変更する",
        "不要"
    ],
    "ko": [
        "한국어로 읽고 싶으신가요?",
        "한국어로 변경",
        "아니요, 괜찮습니다"
    ],
    "nb": [
        "Vil du lese det på Norsk?",
        "Endre til Norsk",
        "Nei, takk!"
    ],
    "nl": [
        "Wilt u het in het Nederlands lezen?",
        "Omschakelen naar het Nederlands",
        "Nee, bedankt"
    ],
    "pl": [
        "Chcesz to przeczytać w języku: Polski?",
        "Zmień na Polski",
        "Nie, dziękuję"
    ],
    "pt": [
        "Deseja ler em Português (BR)?",
        "Mudar para Português (BR)",
        "Não, obrigado"
    ],
    "ro": [
        "Vrei să citești în Română?",
        "Schimbă în Română",
        "Nu, mulțumesc"
    ],
    "ru": [
        "Хотите читать на Русский?",
        "Изменить на Русский",
        "Нет, спасибо"
    ],
    "sv": [
        "Vill du läsa det på Svenska?",
        "Ändra till Svenska",
        "Nej tack"
    ],
    "tr": [
        "Türkçe olarak okumak ister misiniz?",
        "Türkçe olarak değiştir",
        "Hayır, teşekkürler"
    ],
    "zh": [
        "您希望切换成简体中文吗？",
        "切换成简体中文",
        "不用了，谢谢"
    ]
}